import {Box} from "@mui/material"
import priorityLogo from "../../logo/unnamed.webp"
import zohoLogo from "../../logo/Zoho CRM.png"
import workatoLogo from "../../logo/workato logo.webp"
import { logDOM } from "@testing-library/react";
const SourceIcon = ({ source }) => {
  
  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // bgcolor: source === "Priority" ? "primary.main" : source == "ZohoCRM"? "success.main" : "blue",
        color: "white",
        fontSize: "0.75rem",
        fontWeight: "bold",
        overflow: "hidden", // Add this to keep the image within the border radius
        position: "relative"
      }}
    >
      {source === "Priority"
        ? (
          <img 
            src={priorityLogo} 
            alt="Priority"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        )
        : source === "ZohoCRM"
        ? (
          <img 
            src={zohoLogo} 
            alt="ZohoCRM"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        )
        : source === "Interface"
        ? <img 
        src={workatoLogo} 
        alt="Interface"
        style={{
          maxWidth: '25px',  // Reduced from 100%
          maxHeight: '25px', // Reduced from 100%
          objectFit: 'contain', // Changed from 'cover' to 'contain'
          margin: 'auto'
        }}
      />
        : ""}
    </Box>
  );
};

export default SourceIcon